import {DriverModel} from './driver.model';
import {VehicleModel} from './vehicle.model';
import {InsuredModel} from './insured.model';
import {ImpactPointModel} from './impact-point.model';
import {FileModel} from './file.model';
import {Company, CounterpartyCompany} from './insurance-company.model';
import {PlaceRepair} from './appointment-repair.model';
import {EsbCounterpartResponse} from './esb-data-for-counterpart.model';
import {RepairAuthorityWorkingModel} from './repair-authority-working.model';

export const REPAIR_STATUS: string = 'REPAIR_STATUS';
export class CounterpartyModel {

	assigned_at?: string;
	assigned_to?: AssignedTo;
	attachments?: FileModel[];
	canalization?: Canalization;
	claims_id?: string;
	counterparty_id: string;
	created_at?: string;
	date_accident_from?: string;
	date_accident_to?: string;
	description?: string;
	driver: DriverModel;
	eligibility?: boolean;
	historicals?: Historical[];
	impact_point: ImpactPointModel;
	insurance_company: CounterpartyCompany;
	insured: InsuredModel;
	is_cai_signed: boolean;
	last_contact?: Lastcontact[];
	locator?: string; //TODO:
	locality: string; //TODO:
	manager?: ManagerRepair;
	policy_beginning_validity?: string;
	policy_end_validity?: string;
	policy_number?: string;
	practice_id?: number;
	procedure_repair: ProcedureRepair;
	responsible: boolean;
	status_repair?: string;                //TODO:
	repair_status?: CounterpartStatus;  //TODO:
	type: string;
	update_at?: string;
	user_create?: string;
	user_update?: string;
	vehicle: VehicleModel;
	region?: string;
	authorities?: RepairAuthorityWorkingModel[];


	management_type: ManagementType;
	asked_for_damages: boolean;
	legal_or_consultant: boolean;
	date_request_damages: string;
	expiration_date: string;
	legal: string;
	email_legal: string;
	replacement_car?: boolean;
	replacement_plate?: string;
	repair_created_at?: string;
	motivation?: string;
	checked?: boolean;

	is_ald: boolean;
	is_complete_documentation: boolean;
	patchDataFromEsbResponse(esbResponse: EsbCounterpartResponse): CounterpartyModel {
		this.is_ald = !esbResponse.isEmpty();
		this.insured = {
			customer_id: esbResponse.customer.customer_id,
			address: esbResponse.customer.main_address,
			driving_license: null,
			email: esbResponse.customer.email,
			firstname: esbResponse.customer.trading_name,
			lastname: esbResponse.customer.legal_name,
			fiscal_code: esbResponse.customer.vat_number,
			phone: esbResponse.customer.phonenr
		};
		this.vehicle = new VehicleModel(esbResponse.vehicle);
		this.insurance_company = {
			entity: {...new Company(), ...esbResponse.insurance_company},
			name: esbResponse.insurance_company.name
		};
		this.policy_number = esbResponse.policy_number;
		this.policy_beginning_validity = esbResponse.policy_beginning_validity;
		this.policy_end_validity = esbResponse.policy_end_validity;
		return this;
	}
}

export enum ManagementType {
	REPAIR = 'REPAIR',
	PREVENTIVE = 'PREVENTIVE'
}

export enum CounterpartStatus {
	// WAITING_FOR_NETWORK = 'WAITING_FOR_NETWORK',
	// WAITING_DOCUMENTS = 'WAITING_DOCUMENTS',
	// MANAGEABLE = 'MANAGEABLE',
	// MSA_MANAGE = 'MSA_MANAGEMENT',
	// CLOSED = 'CLOSED',
	// REPAIRING = 'REPAIRING',

	// CONFIRMED_LIQUIDATE = 'CONFIRMED_LIQUIDATE',
	// WAITING_FOR_INVOICE = 'WAITING_FOR_INVOICE',
	// WAITING_FOR_NETWORK_TO_LIQUIDATE = 'WAITING_FOR_NETWORK_TO_LIQUIDATE',
	// WAITING_FOR_NETWORK_TO_REPAIR = 'WAITING_FOR_NETWORK_TO_REPAIR',

	TO_SORT = 'TO_SORT',
	TO_CONTACT = 'TO_CONTACT',
	TO_RECONTACT = 'TO_RECONTACT',
	WAITING_FOR_QUOTATION = 'WAITING_FOR_QUOTATION',
	QUOTATION_APPROVED = 'QUOTATION_APPROVED',
	UNDER_REPAIR = 'UNDER_REPAIR',
	UNDER_LIQUIDATION = 'UNDER_LIQUIDATION',
	REPAIRED = 'REPAIRED',
	CLOSED_LIQUIDATED = 'CLOSED_LIQUIDATED',
	CLOSED_REPAIRED = 'CLOSED_REPAIRED',
	CLOSED_DENIAL = 'CLOSED_DENIAL',
	WSREPAIR = 'WSREPAIR',
}

export enum CounterpartyType {
	VEHICLE = 'VEHICLE',
	OTHER = 'OTHER'
}

export class Canalization {
	date: string;
	center: PlaceRepair;
}

//  interface CounterpartCenter {
//     address: string;
//     address_number: string;
//     ald_commodity_id: string;
//     ald_supplier_code: string;
//     contact_phone: string;
//     distance: string;
//     email: string;
//     fiscal_code: string;
//     has_dedicated_expert: boolean;
//     municipality: string;
//     name: string;
//     place_id: string;
//     province_code: string;
//     region: string;
//     type: string;
//     vat_number: string;
//     zip_code: string;
// }


export interface ManagerRepair {
	address: string;
	contact: string;
	country: string;
	email: string;
	external_export_id: string;
	fax: string;
	id: string;
	is_active: boolean;
	locality: string;
	name: string;
	phone: string;
	prov: string;
	website: string;
	zip_code: number;
}


export interface Historical {
	comunication_description: string;
	description: string;
	new_status: string;
	old_status: string;
	update_at: string;
	user_id: string;
}


export interface Lastcontact {
	last_call: string;
	motivation: MotivationRepair;
	note: string;
	recall: string;
	result: string;
}

export interface MotivationRepair {
	answer_type: string;
	description: string;
	id: string;
	is_active: boolean;
}

export enum ProcedureRepair {
	ALD_REPAIRING = 'ALD_REPAIRING',
	STANDARD = 'STANDARD',
}

export interface AssignedTo {
	id: string;
	personal_details: PersonalDetailsCounterpart;
	username: string;
}

interface PersonalDetailsCounterpart {
	birth_country: string;
	birth_date: string;
	birth_place: string;
	birth_province: string;
	firstname: string;
	gender: string;
	lastname: string;
	office_role: string;
	phone: string;
	tax_code: string;
}

export const COUNTERPARTY_NOT_ELIGIBLE: string = 'COUNTERPARTY_NOT_ELIGIBLE';

export class CounterpartyModelDTO {
	claims_id?: string;
	counterparty_id: string;
	date_accident_from?: string;
	date_accident_to?: string;
	description?: string;
	driver: DriverModel;
	impact_point: ImpactPointModel;
	insurance_company: CounterpartyCompany;
	insured: InsuredModel;
	is_cai_signed: boolean;
	locator?: string; //TODO:
	locality: string; //TODO:
	policy_beginning_validity?: string;
	policy_end_validity?: string;
	policy_number?: string;
	practice_id?: number;
	procedure_repair: ProcedureRepair;
	responsible: boolean;
	type: string;
	user_update?: string;
	vehicle: VehicleModel;
	region?: string;
	motivation?: string;
	checked?: boolean;
	is_ald: boolean;

	constructor(model: CounterpartyModel) {
		this.claims_id = model.claims_id;
		this.counterparty_id = model.counterparty_id;
		this.date_accident_from = model.date_accident_from;
		this.date_accident_to = model.date_accident_to;
		this.description = model.description;
		this.driver = model.driver;
		this.impact_point = model.impact_point;
		this.insurance_company = model.insurance_company;
		this.insured = model.insured;
		this.is_cai_signed = model.is_cai_signed;
		this.locator = model.locator;
		this.locality = model.locality;
		this.policy_beginning_validity = model.policy_beginning_validity;
		this.policy_end_validity = model.policy_end_validity;
		this.policy_number = model.policy_number;
		this.practice_id = model.practice_id;
		this.procedure_repair = model.procedure_repair;
		this.responsible = model.responsible;
		this.type = model.type;
		this.user_update = model.user_update;
		this.vehicle = model.vehicle;
		this.region = model.region;
		this.motivation = model.motivation;
		this.checked = model.checked;
		this.is_ald = model.is_ald;
	}
}
